require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./2018-06-24-kian-fun-fun-fun.json") })
        }
      }, "path---2018-06-24-kian-fun-fun-fun");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---2018-06-24-kian-fun-fun-fun!./.cache/json/2018-06-24-kian-fun-fun-fun.json
// module id = 505
// module chunks = 231608221292675